import * as actionTypes from "../ActionTypes";

// 🔹 Save Service
export const saveServiceRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_SERVICE_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const saveServiceSuccess = (data) => ({
  type: actionTypes.SAVE_SERVICE_SUCCESS,
  payload: data,
});

export const saveServiceFailure = (error) => ({
  type: actionTypes.SAVE_SERVICE_FAILURE,
  payload: error,
});
export const saveCampusTimeRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.SAVE_CAMPUS_TIME_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const saveCampusTimeSuccess = (data) => ({
    type: actionTypes.SAVE_CAMPUS_TIME_SUCCESS,
    payload: data,
  });
  
  export const saveCampusTimeFailure = (error) => ({
    type: actionTypes.SAVE_CAMPUS_TIME_FAILURE,
    payload: error,
  });
  export const saveServiceGalleryRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.SAVE_SERVICE_GALLERY_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const saveServiceGallerySuccess = (data) => ({
    type: actionTypes.SAVE_SERVICE_GALLERY_SUCCESS,
    payload: data,
  });
  
  export const saveServiceGalleryFailure = (error) => ({
    type: actionTypes.SAVE_SERVICE_GALLERY_FAILURE,
    payload: error,
  });
  export const deleteServiceRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.DELETE_SERVICE_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const deleteServiceSuccess = (data) => ({
    type: actionTypes.DELETE_SERVICE_SUCCESS,
    payload: data,
  });
  
  export const deleteServiceFailure = (error) => ({
    type: actionTypes.DELETE_SERVICE_FAILURE,
    payload: error,
  });
  export const updateServiceRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.UPDATE_SERVICE_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const updateServiceSuccess = (data) => ({
    type: actionTypes.UPDATE_SERVICE_SUCCESS,
    payload: data,
  });
  
  export const updateServiceFailure = (error) => ({
    type: actionTypes.UPDATE_SERVICE_FAILURE,
    payload: error,
  });
  
  // 🔹 Update Campus & Time
  export const updateCampusTimeRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.UPDATE_CAMPUS_TIME_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const updateCampusTimeSuccess = (data) => ({
    type: actionTypes.UPDATE_CAMPUS_TIME_SUCCESS,
    payload: data,
  });
  
  export const updateCampusTimeFailure = (error) => ({
    type: actionTypes.UPDATE_CAMPUS_TIME_FAILURE,
    payload: error,
  });
  
  // 🔹 Update Service Gallery
  export const updateServiceGalleryRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.UPDATE_SERVICE_GALLERY_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const updateServiceGallerySuccess = (data) => ({
    type: actionTypes.UPDATE_SERVICE_GALLERY_SUCCESS,
    payload: data,
  });
  
  export const updateServiceGalleryFailure = (error) => ({
    type: actionTypes.UPDATE_SERVICE_GALLERY_FAILURE,
    payload: error,
  });
  export const deleteServiceGalleryRequest = ({apiPayloadRequest, callback}) => ({
    type: actionTypes.DELETE_SERVICE_GALLERY_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  
  export const deleteServiceGallerySuccess = (data) => ({
    type: actionTypes.DELETE_SERVICE_GALLERY_SUCCESS,
    payload: data,
  });
  
  export const deleteServiceGalleryFailure = (error) => ({
    type: actionTypes.DELETE_SERVICE_GALLERY_FAILURE,
    payload: error,
  });
  // 🔹 Delete Campus & Time
export const deleteCampusTimeRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.DELETE_CAMPUS_TIME_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const deleteCampusTimeSuccess = (data) => ({
  type: actionTypes.DELETE_CAMPUS_TIME_SUCCESS,
  payload: data,
});

export const deleteCampusTimeFailure = (error) => ({
  type: actionTypes.DELETE_CAMPUS_TIME_FAILURE,
  payload: error,
});
